<template>
    <div class="flex items-start w-full">
        <div class="flex-none mt-1" @click="toggleCheck()">
            <div
                class="w-6 h-6 checkbox flex justify-center items-center rounded border"
                :class="[value ? 'active border-none' : 'border-red-1']"
            >
                <transition
                    enter-active-class="transition ease-out duration-500"
                    enter-from-class="transform opacity-0 scale-50"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-100"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-50"
                >
                    <svg width="14" height="13" fill="none" v-if="value">
                        <path
                            d="m2.472 7.537 2.335 3.044a1 1 0 0 0 1.573.017l5.941-7.396"
                            stroke="#fff"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                    </svg>
                </transition>
            </div>
        </div>

        <template v-if="$slots['label']">
            <div class="flex-auto ml-3">
                <slot name="label" v-bind="$props"></slot>
            </div>
        </template>
        <template v-else>
            <div class="pl-2 flex-auto" v-html="text"></div>
        </template>
    </div>
</template>
<script>
export default {
    name: "VCheckbox",
    props: {
        modelValue: { type: Boolean }, // v-model
        text: { type: String, default: "" },
        lazy: { type: Boolean },
    },
    computed: {
        value: {
            get: function () {
                return this.modelValue
            },
            set: function (newVal) {
                this.$emit("update:modelValue", newVal)
            }
        }
    },
    emits: ["update:modelValue", "toggle"],
    methods: {
        toggleCheck: function () {
            let val = !this.value;
            if (this.lazy == true) {
                this.$emit("toggle", val)
            } else {
                this.value = val
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.checkbox {
    width: 25px;
    height: 25px;
    flex-grow: 0;
    border-radius: 8px;
    background-color: #fff;
    &.active {
        background-image: linear-gradient(to right, #72292f 0%, #e00238 100%);
    }
}
</style>
